import type { JobStatus } from '@/features/jobs/types/job'

const jobStatusLabels: Record<JobStatus, string> = {
  open: 'Open',
  in_progress: 'In progress',
  completed: 'Completed',
  aborted: 'Aborted',
  cancelled: 'Cancelled',
}

export const formatJobStatus = (status: JobStatus) => jobStatusLabels[status]
